document.addEventListener('click', function(event) {
  // Check if the clicked element has the class 'form-sheet-submit-btn'
  // alert('hii');
  if (event.target.classList.contains('form-sheet-submit-btn')) {
    const newsLetterInputs = document.querySelectorAll('.newsletter-form__field-wrapper .footer-newsletter-input');
    const pincode = newsLetterInputs[0].value.trim();
    const phone = newsLetterInputs[1].value.trim();
    const errorMsg = document.querySelector('.error-message-text');

    const isValidPincode = /^\d{6}$/.test(pincode);
    const isValidPhone = /^\d{10}$/.test(phone);

    if (!isValidPincode) {
      errorMsg.innerHTML = 'Please enter a valid 6-digit pincode.';
      return; // Stop further execution
    }

    if (!isValidPhone) {
      errorMsg.innerHTML = 'Please enter a valid 10-digit phone number.';
      return; // Stop further execution
    }

    // Get product info for category mapping
    const productType = document.body.dataset.productType || '';
    const productTitle = document.body.dataset.productTitle || '';
    const collectionHandle = document.body.dataset.collectionHandle || '';
    const productId = document.body.dataset.productId || '';
    
    // Map to standardized Primary Product Category (using centralized function)
    const primaryProductCategory = window.getPrimaryProductCategory ? window.getPrimaryProductCategory(productType, productTitle, collectionHandle, productId) : '';

    fetch("https://apis.thesleepcompany.in/lead/datafeed", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
          pincode: pincode,
          phone: phone,
          source: "Newsletter Community",
          lead_status: "Tier 1",
          activity_source: "Newsletter Community",
          activity_note: pincode,
          ...(primaryProductCategory && { mx_Primary_Product_Category: primaryProductCategory }),
          ...(primaryProductCategory && { activity_code: 208 }),
          ...(primaryProductCategory && { mx_custom_48: primaryProductCategory }),
          mx_mobile_device: getDeviceModel(),
          mx_mobile_os: getOSWithVersion(),
          is_web_engage_event: true,
          web_engage_data: {
              pincode: pincode,
              phone: phone,
          },
          ...(primaryProductCategory && { web_engage_user_data: { category: primaryProductCategory } }),
      }),
    })

    gaEvent('send_my_discount_code', ['send_my_discount_code', '',pincode,`+91${phone}`,'',''], false);
  }
});

if(window.templateData.suffix === 'new-comparison'){
  $(document).ready(function() {
    $('#storeLocatorLink').on('click', function() {
      const href = $(this).attr('href');
      const productName = window.productDetails ? window.productDetails.titleJson : '';
      gaEvent('store_visit', ['side_bar', href, '', '', productName ? productName : '', ''], false);
    });
  });
}